<template>
  <div
    class="popup_wrap"
    style="width:1300px; height:600px; overflow: hidden"
  >
    <button
      class="layer_close"
      @click="$emit('close')"
    >
      close
    </button>
    <h1 class="page_title">{{ $t('msg.VOSD100_M5.011') }}<!-- 스케줄조회 --></h1>
    <div class="popup_cont" style="overflow-y: auto; max-height: 500px;">
      <!-- popup_cont -->
      <ScheduleLeg @close="closePopup" @ScheduleLegPop="throwBkgParams" :parent-info="parentInfo"></ScheduleLeg>
    </div><!-- popup_cont -->
  </div>
</template>
<script>
import ScheduleLeg from '@/pages/schedule/ScheduleLeg'

export default {
  name: 'ScheduleLegPop',
  components: {
    ScheduleLeg
  },
  props: {
    parentInfo: {
      type: Object,
      default: function () {
        return {
          ScheduleLegPop: 'N',
          cancelRequestPop: 'N',
          rfYn: 'Y'
        }
      }
    }
  },
  data: function () {
    return {}
  },
  computed: {
  },
  watch: {
  },
  created () {
    console.log('<<<<<< scheduleLegPop / parentInfo >>>>>>')
    console.log(this.parentInfo)
  },
  methods: {
    closePopup () {
      this.$emit('close')
    },
    throwBkgParams (obj) {
      console.log('@@@@@ Pop-up >>> throwBkgParams obj Data @@@@@')
      console.log(obj)
      this.$emit('selectFunc', obj)
    }
  }
}
</script>
